import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import BlockLayout from './BlockLayout';
import BlockProfit from './BlockProfit';

import './block-detail.scss';
import ButtonArrowed from '../widgets/Buttons/ButtonArrowed';

class TextContent extends PureComponent {
  render() {
    return (
      <div className={cn('story-text-content', this.props.name)}>
        <h2 dangerouslySetInnerHTML={{ __html: this.props.title }} />

        <p dangerouslySetInnerHTML={{ __html: this.props.description }} />

        <span dangerouslySetInnerHTML={{ __html: this.props.cities }} />
      </div>
    );
  }
}

TextContent.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cities: PropTypes.string.isRequired
};

class BlockDetail extends PureComponent {
  render() {
    const { story } = this.props;

    return (
      <div className="block-detail">
        <TextContent
          name={this.props.name}
          title={this.props.title}
          description={this.props.description}
          cities={this.props.cities}
        />

        {(!!story.programLink) &&
          <div className="learn-more">
            <ButtonArrowed
              direction="right"
              link={story.programLink}
            >
              Описание услуги
            </ButtonArrowed>
          </div>
        }

        {(!!story.profitRate && !!story.rateDate) &&
          <BlockProfit
            profitRate={story.profitRate}
            rateDate={story.rateDate}
          />
        }

        <BlockLayout {...this.props.blocks}/>

        <button
          type="button"
          className="btn btn-flex solid-white"
          onClick={this.props.onOpenClick}
        >
          <span>
            <em>Подробнее<span className="icon">→</span></em>
            Детали программы
          </span>
        </button>
      </div>
    );
  }
}

BlockDetail.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cities: PropTypes.string.isRequired,
  blocks: PropTypes.shape({
    layout: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(PropTypes.object).isRequired
  }).isRequired,
  story: PropTypes.shape({
    profitRate: PropTypes.string,
    rateDate: PropTypes.string,
    programLink: PropTypes.string
  }),
  onOpenClick: PropTypes.func.isRequired
};

export default BlockDetail;



// WEBPACK FOOTER //
// ./src/components/SuccessStory/BlockDetail.js